export enum EPenaltyReason {
  NO_CONTRIBUTION_HISTORY = "NO_CONTRIBUTION_HISTORY",
  LATE_REMITTANCE = "LATE_REMITTANCE",
  COMPLIANT = "COMPLIANT",
  NO_OBLIGATION_YET = "NO_OBLIGATION_YET",
  GAP_MONTHS = "GAP_MONTHS",
  PENALTY_OUTSTANDING = "PENALTY_OUTSTANDING",
}

export enum EPenaltyStatus {
  GAP_DETECTED = "GAP_DETECTED",
  PENALTY_COMPUTED = "PENALTY_COMPUTED",
}
